// extracted by mini-css-extract-plugin
export default {"nav":"TopBar_nav__aZSGl","spacer":"TopBar_spacer__gexW9"};